import { render, staticRenderFns } from "./StorePermissionTree.vue?vue&type=template&id=0ecfe5c8&scoped=true"
import script from "./StorePermissionTree.vue?vue&type=script&lang=js"
export * from "./StorePermissionTree.vue?vue&type=script&lang=js"
import style0 from "./StorePermissionTree.vue?vue&type=style&index=0&id=0ecfe5c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecfe5c8",
  null
  
)

export default component.exports